import data from "../../../../../src/BranchName/BranchName.docs.json";
import * as React from 'react';
export default {
  data,
  React
};